import { render, staticRenderFns } from "./BatchClientsAdd.vue?vue&type=template&id=d0839d92&scoped=true"
import script from "./BatchClientsAdd.vue?vue&type=script&lang=js"
export * from "./BatchClientsAdd.vue?vue&type=script&lang=js"
import style0 from "./BatchClientsAdd.vue?vue&type=style&index=0&id=d0839d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0839d92",
  null
  
)

export default component.exports